import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from '@Sage/hoi-poi-ui';
import { DetailActions } from 'actions';
import useDrawerWidth from 'hooks/useDrawerWidth';

import DetailHeader from './DetailHeader';
import GenericDetailContent from './GenericDetailContent';

const DetailContainer = memo(() => {
    const dispatch = useDispatch();

    const show = useSelector((state) => state.detail.tabs.size > 0);
    const entityType = useSelector((state) => {
        const tab = state.detail.tabs.get(state.detail.select);
        return tab ? tab.get('entityType') : null;
    });

    const drawerWidth = useDrawerWidth({ entityType, isOpen: show });

    const handleClose = useCallback(() => {
        dispatch(DetailActions.hideDetail());
    }, [dispatch]);

    return (
        <Drawer
            hideOverlay
            isOpen={show}
            onRequestClose={handleClose}
            side="right"
            width={drawerWidth}
        >
            {show && (
                <div className="react-detail">
                    <DetailHeader />
                    <GenericDetailContent />
                </div>
            )}
        </Drawer>
    );
});

DetailContainer.displayName = 'DetailContainer';

export default DetailContainer;
